import { Pipe, PipeTransform } from '@angular/core';
import { VenueType } from '@shared/enums/VenueType';
import { IEvent } from '@shared/services/api/dashboard/events-service/events-model';

@Pipe({
    name: 'hasVenuesOnline'
})
export class HasVenuesOnlinePipe implements PipeTransform {
    transform(eventDetails: IEvent): boolean {
        return eventDetails?.locationDateTimes?.every(x => x.venueType === VenueType.Online);
    }
}
